module.exports = __webpack_public_path__ + "img/essg2.629202cb.jpg";